import { AppConfig } from '../interfaces/AppConfig';

export let config: AppConfig;
declare const APPLICATION_ENV;

export const initializeConfig = async () => {
    const env = (APPLICATION_ENV || 'production').toLowerCase();

    switch (env.toString()) {
        case 'development':
            config = require('./config.development').default;
            break;
        case 'staging':
            // config = (await import('./config.staging')).default;
            config = require('./config.staging').default;
            break;
        case 'production':
            config = require('./config.production').default;
            break;
    }
};
